<template>
  <div class="contain">
    <div
      style="width: 100%;position: fixed;top: 0;z-index: 999;background: #fff;box-shadow: -6px 2px 17px 0px rgba(87,138,255,0.1);">
      <div class="logo" style="margin: 0 auto;background: #fff;">
        <div style="height: 70px;display: flex;align-items: center;padding: 0 80px;background: #fff;">
          <img src="../../assets/images/logo2.png" style="width: 144px;height: 40px;cursor: pointer;" @click="goHome">
        </div>
      </div>
    </div>
    <div style="height: 70px;"></div>

    <div class="contenthtml">
      <div class="content">
        <div style="font-size: 32px;font-family: PingFangSC-Medium, PingFang SC;color: #36444D;line-height: 45px;">
          {{content.title}}</div>
        <div style="margin: 28px 0;display: flex;align-items: center;">
          <img src="../../assets/images/time.png" style="width: 16px;height: 16px;margin-right: 10px;">
          <span
            style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #767D8A;line-height: 22px;">{{content.publishTime}}</span>
        </div>
        <div v-html="content.content"></div>
      </div>
      <div class="rightContent">
        <div class="weChat">
          <img :src="baseURL + info.kfQrcode" style="width: 176px;height: 176px;">
          <div>官方客服微信</div>
        </div>
        <div class="recommend">
          <div class="read">
            <div class="readT">推荐阅读</div>
            <div v-for="(item, index) in hotWZ" :key="index" class="readList" @click="toDetails(item.id)">
              <div class="wzTitle">{{item.title}}</div>
              <div class="wzContent">{{item.contentTitle}}</div>
            </div>
          </div>
          <div class="label">
            <div class="labelT">热门标签</div>
            <div>
              <span class="labelList" v-for="(item, index) in labelList" :key="index" @click="toDetails(item.id)">
                {{item.label}}
              </span>
            </div>
          </div>
          <div class="question">
            <div class="questionT">热门问答</div>
            <div>
              <div class="questionList" v-for="(item, index) in questionList" :key="index">
                <div class="wzTitle">Q：{{item.question}}</div>
                <div class="wzContent">A：{{item.answer}}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  </div>
  </div>
</template>
<script>
  import {
    getLinks,
    getInfo,
    getMedia,
    articleById,
    setHotArticles,
    getLabelList,
    getquestionList
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  export default {
    name: 'home',
    components: {

    },
    data() {
      return {
        activeName: '5',
        article: [],
        baseURL: '',
        media: [],
        linkList: [],
        info: {},
        id: '',
        content: {},
        hotWZ: [],
        labelList: [],
        questionList: []
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.baseURL = serverUrl.baseURL
      this.setMedia()
      this.setInfo()
      this.setLinks()
      this.setArticleById()
      this.getgetHotArticles()
      this.setLabelList()
      this.setquestionList()
    },
    methods: {
      toDetails(id) {
        this.$router.push({
          path: '/newsDetails',
          query: {
            id
          }
        })
         location.reload()
      },
      setquestionList() {
        getquestionList().then(res => {
          this.questionList = res.content
        })
      },
      setLabelList() {
        getLabelList().then(res => {
          this.labelList = res
        })
      },
      getgetHotArticles() {
        setHotArticles().then(res => {
          this.hotWZ = res
        })
      },
      goHome() {
        this.$router.push({
          path: '/',
        })
      },
      setMedia() {
        getMedia().then(res => {
          this.media = res
        })
      },
      setLinks() {
        getLinks().then(res => {
          this.linkList = res
        })
      },
      setInfo() {
        getInfo().then(res => {
          this.info = res
        })
      },
      setArticleById() {
        articleById({
          id: this.id
        }).then(res => {
          this.content = res
        })
      },
    },

    created() {



    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media (max-width: 1500px) {

    .logo,
    .banner1,
    .xwzx,
    .banner2,
    .dataGrowth,
    .newsBanner1,
    .tabList,
      {
      width: 1440px;
    }

    .content {
      width: 50%;
    }

    .bj1 {
      box-sizing: border-box;
      width: 1274px;
      height: 184px;
      margin: 0 auto;
      position: absolute;
      bottom: -92px;
      background: url(../../assets/images/bj_1.png) top center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hotArticlesTitle {
      width: 334px;
    }

    .hotArticlesContent {
      width: 334px;
    }


  }

  @media (min-width: 1500px) {

    .logo,
    .banner1,
    .xwzx,
    .banner2,
    .dataGrowth,
    .newsBanner1,
    .tabList,
    .contenthtml {
      width: 1640px;
    }



    .bj1 {
      box-sizing: border-box;
      width: 1434px;
      height: 184px;
      margin: 0 auto;
      position: absolute;
      bottom: -92px;
      background: url(../../assets/images/bj_1@2x.png) top center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hotArticlesTitle {
      width: 388px;
    }

    .hotArticlesContent {
      width: 388px;
    }
  }

  .contenthtml {
    margin: 0 auto;
    padding: 50px 80px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {
    display: none !important;
    /* Chrome */
  }

  .rightContent {
    width: 30%;
    margin-left: 20px;
  }

  .recommend {
    width: 100%;
    padding: 30px 0;
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0px 2px 11px 3px rgba(145, 148, 168, 0.09);
    border-radius: 10px;
  }

  .readList {
    margin-top: 20px;
    cursor: pointer;
  }

  .read,
  .label {
    padding: 20px 0;
    margin: 0 20px;
    border-bottom: 1px dashed #C4D0E9
  }

  .question {
    padding: 20px 0;
    margin: 0 20px;
  }

  .readT,
  .labelT,
  .questionT {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #36444D;
    line-height: 28px;
  }

  .questionList {
    margin-top: 20px;
  }

  .wzTitle {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #383F4B;
    line-height: 26px;
  }

  .wzContent {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #767D8A;
    line-height: 26px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .weChat {
    width: 100%;
    height: 245px;
    background: #FFFFFF;
    box-shadow: 0px 2px 11px 3px rgba(145, 148, 168, 0.09);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .weChat>div {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #36444D;
    line-height: 20px;
    margin-top: 10px;
  }

  .content {
    width: 70%;
    padding-top: 45px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 3px rgba(162, 167, 203, 0.09);
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
  }

  .contain {
    overflow-x: hidden;
    height: 100vh;
    position: relative;
  }

  .newsBanner {
    width: 100%;
    height: 219px;
    background: url(../../assets/images/newsBanner.png) top center no-repeat;
    background-size: cover;
  }

  .newsBanner1 {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 100px;
    box-sizing: border-box;
  }

  .tabList {
    margin: 0 auto;
    padding: 0 100px;
    box-sizing: border-box;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background: #fff;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #00C9AD;
  }

  /deep/ .is-active {
    font-weight: 500 !important;
    color: #00C9AD !important;
  }

  /deep/ .el-tabs__item {
    color: #8B9FA7;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding: 0 30px;
  }

  /deep/ .el-tabs__item:hover {
    color: #00C9AD;
  }

  .el-tabs {
    margin: 46px 0 36px;
  }

  a {
    color: #6C7480;
  }

  .erweima {
    display: none;
  }

  .weixin:hover .erweima {
    display: block !important;
  }

  .kf:hover {
    background: #F8FFFF;
    border-radius: 100px 100px 0px 0px;
  }

  .kf:hover .kfQr {
    display: block !important;
  }

  .labelList {
    cursor: pointer;
    display: inline-block;
    padding: 5px 10px;
    background: #F4F7FD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #383F4B;
    margin: 20px 10px 0px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/NewsDetails.vue